import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkedAlt } from '@fortawesome/pro-regular-svg-icons/faMapMarkedAlt'

import IFrameHtml from '@peracto/peracto-editor-ui/dist/IFrameHtml'
import { isInStorefront } from '../../utils/isInStorefront'

const IFrameContent = styled.div`
    position: relative;
    padding-top: ${props => (props.hasUrl ? '25px' : 0)};
    height: ${props => (props.hasUrl ? 0 : '100%')};
    padding-bottom: ${props => {
        if (props.hasUrl) {
            switch (props.aspectRatio) {
                case '4:3':
                    return `75%`
                case '16:9':
                    return `56.25%`
                case '2:1':
                    return `50%`
                default:
                    return `100%`
            }
        } else {
            return '0'
        }
    }};

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    p {
        text-align: center;
        margin: 1rem 0;
    }
`

const IFrameOverlay = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
`
const getMapUrl = (url, zoomLevel) => {
    const zoom = url.match(/(1d)(.*)(!2d)/)
    const replace = zoom && zoom.length > 1 ? zoomLevel * 1000 : null
    return replace ? url.replace(zoom[2], replace) : url
}

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faMapMarkedAlt} size="6x" />
    </div>
)

const MapComponent = ({ state: { url, aspectRatio, zoomLevel }, isEditMode }) => {
    const hasUrl = url && url.length > 0

    const inStorefront = isInStorefront()

    const iframe = useMemo(
        () => (hasUrl ? <IFrameHtml content={getMapUrl(url, zoomLevel)} /> : null),
        [hasUrl, url, zoomLevel]
    )

    return (
        <IFrameContent aspectRatio={aspectRatio} hasUrl={hasUrl} className="content__map">
            {hasUrl ? (
                <>
                    {iframe}
                    {isEditMode && <IFrameOverlay />}
                </>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </IFrameContent>
    )
}

export default MapComponent
